import { Component, Input, OnInit } from '@angular/core';
import { helpUrlsLookup } from 'go-modules/help-urls/help-urls.constant';
import type { LtiLmsNameMappings } from '@lti/app/types';
import { ActiveBrandService } from '@go-modules/services/active-brand';

@Component({
	selector: 'missing-parameters-error-renderer',
	templateUrl: './missing-parameters-error.component.html',
	styleUrls: ['./missing-parameters-error.component.scss'],
	standalone: false
})
export class MissingParametersErrorComponent implements OnInit {
	@Input() public errors: any;
	@Input() public mappings: LtiLmsNameMappings;

	public showErrors = false;
	public setupInstructionsLink: string;
	public contactSupport: string;

	public constructor (private activeBrandService: ActiveBrandService) {}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public ngOnInit (): void {
		this.contactSupport = helpUrlsLookup.contactSupport;
		// This link is the required params page
		this.setupInstructionsLink = helpUrlsLookup.lmsIntegrationDetails;
	}

	public toggleErrors (): void {
		this.showErrors = !this.showErrors;
	}
}
